import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import BaseInput from './Inputs/BaseInput.vue'

import BaseCheckbox from './BaseCheckbox.vue'
import BaseRadio from './BaseRadio.vue'
import BaseDropdown from './BaseDropdown.vue'
import BaseTable from './BaseTable.vue'
import BaseButton from './BaseButton'
import BaseAlert from './BaseAlert'
import BaseNav from './BaseNav'
import Modal from './Modal'
import CloseButton from './CloseButton'

import Card from './Cards/Card.vue'
import StatsCard from './Cards/StatsCard.vue'

import SidebarPlugin from './SidebarPlugin/index'

const requireComponent = require.context(
  '@/components', true, /\.vue$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

export {
  BaseInput,
  Card,
  Modal,
  CloseButton,
  StatsCard,
  BaseTable,
  BaseCheckbox,
  BaseRadio,
  BaseDropdown,
  BaseButton,
  BaseAlert,
  SidebarPlugin,
  BaseNav
}
